import { useEffect } from 'react'
import { useRouter } from 'next/router'
import Spinner from 'src/@core/components/spinner'

import { AuthUserContextFirebase } from '../@core/context/FirebaseContext'
import useFirebaseAuth from 'src/@core/hooks/useFirebaseAuth'
import { useDispatch } from 'react-redux'

/**
 *  Set Home URL based on User Roles
 */
export const getHomeRoute = (role: string) => {
  if (role === 'client') return '/home'
  else return '/home'
}
const Home = () => {
  const dispatch = useDispatch()
  const { authUser, loading } = useFirebaseAuth(dispatch) as AuthUserContextFirebase
  const router = useRouter()
  useEffect(() => {
    if (!router.isReady || loading) {
      return
    }
    const homeRoute = getHomeRoute('client')
    if (!loading && authUser) {
      // Redirect user to Home URL
      router.replace(homeRoute)
    } else if (!loading && authUser === undefined) {
      router.replace('/login')
    }
  }, [authUser, loading])

  return <Spinner />
}

export default Home
